module.exports = __webpack_public_path__ + "static/media/roller-shutter-spraying-001-thumbnail.bb76f73e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/thumbnails/roller-shutter-spraying-001-thumbnail.jpg
// module id = 107
// module chunks = 0